
import api from "./api";

export const getEmployyesforTransfor = async (state,district,seletedDesignation) => {
  const response = await api.get(`api/employee-posting/posting/filter?stateId=${state}&districtId=${district}&designationId=${seletedDesignation}`);
  return response;
}
